const PROD = "prod";
const TEST = "test";
const DEV = "dev";
const LOCAL = "local";

let currentBaseUrl = baseUrlFromEnv(PROD);

/**
 * Get the configured base URL from which to load dynamic components.
 * @return {string} the current base URL, defaults to production URL.
 */
export function getBaseUrl() {
  return currentBaseUrl;
}

/**
 * Set the dynamic component loading environment.
 *
 * If an options object is passed and both an env name and a base URL are
 * provided, the base URL will be used instead of the pre-configured env url.
 *
 * @param {EnvName|EnvOpts} envOrOpts environment name or options
 */
export function setEnv(envOrOpts) {
  let opts = envOrOpts;
  if (typeof opts === "string") {
    opts = { env: opts };
  }
  const { env = PROD, baseUrl = null } = opts;

  if (baseUrl) {
    currentBaseUrl = baseUrl;
  } else {
    currentBaseUrl = baseUrlFromEnv(env);
  }
}

/**
 * Gets the URL for an environment name
 * @param {EnvName} env env name
 * @return {string} url
 */
function baseUrlFromEnv(env) {
  switch (env) {
    case PROD:
      return "https://www.nuskin.com/static/account-components/";
    case TEST:
      return "https://test.nuskin.com/static/account-components/";
    case DEV:
      return "https://apps.dev.nuskin.io/static/account-components/";
    case LOCAL:
      return "http://localhost:6006/";
    default:
      throw new Error("Invalid dynamic component environment");
  }
}

/**
 * @typedef {('local'|'dev'|'test'|'prod')} EnvName
 */

/**
 * @typedef {{}} EnvOpts
 * @property {EnvName} [env] named environment
 * @property {string} [baseUrl] base URL for fetching dynamic components.
 */
